/*
 * @Date: 2023-03-03 16:41:08
 * @LastEditors: Leo
 * @LastEditTime: 2023-05-22 10:40:31
 * @FilePath: \3.0-manger\src\js\components\cart-drawer.js
 */
import { setContentWidth, resetContentWidth } from '@utils/index.js'
import "./index.less"
export class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

export class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    !$(event.target).parents('.baojiadanForm').length > 0 && this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() { // FIX: SECTION RENDERING API最大sections参数数量为5
    if(document.querySelector("header-v5")) {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items')?.dataset?.id,
          selector: '.js-contents',
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer')?.dataset?.id,
          selector: '.js-contents',
        },
        {
          id: 'cart-icon-v5-menu-main',
          section: 'header-v5-main',
          selector: '.header-actions--cart'
        },
        {
          id: 'cart-icon-v5-menu-top',
          section: 'header-v5',
          selector: '#cart-icon-v5-menu-top'
        }
      ]; 
    } else {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items')?.dataset?.id,
          selector: '.js-contents',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer')?.dataset?.id,
          selector: '.js-contents',
        }
      ];
    }
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity: Number(quantity),
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });


    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        if(parsedState.error || parsedState.errors) {
          window.__cart_error = parsedState.error || parsedState.errors
        }
        if(parsedState.error) return
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        this.getSectionsToRender().forEach((section => {
          if(!section.id || !document.getElementById(section.id)) { return }
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();

        setTimeout(() => {
          const cart_items = $("#cart-icon-bubble .cart-count-bubble span, #cart-icon-v5-menu-top .cart-count-bubble span");
          cart_items.each((index, element) => {
            const cart_item = $(element).text();
            if (cart_item) {
              $(".m-header-icon .jackery-icon-gouwuche .cart-count-bubble").eq(index).html(cart_item);
            } else {
              $(".m-header-icon .jackery-icon-gouwuche .cart-count-bubble").eq(index).hide();
            }
          });
        }, 100);
        // setTimeout(() => {
        //   const cart_item = $("#cart-icon-bubble .cart-count-bubble span").eq(0).text();
        //   if (cart_item) {
        //     $(".m-header-icon .jackery-icon-gouwuche .cart-count-bubble").html(cart_item);
        //   } else {
        //     $(".m-header-icon .jackery-icon-gouwuche .cart-count-bubble").hide()
        //   }
        // }, 100)
      }).catch((e) => {
        console.error(e)
        this.querySelectorAll('.loading-overlay') && this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        
        if(window.__cart_error) {
          errors.textContent = window.__cart_error;
          window.__cart_error = ''
        } else {
          errors.textContent = window.pageInfo.strings.cartStrings.error;
        }
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = $(`#Line-item-error-${line}, #CartDrawer-LineItemError-${line}`)
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError.find('.cart-item__error-text').html(window.pageInfo.strings.cartStrings.quantityError.replace(
        '[quantity]',
        quantityElement.value
      ));
    }

    this.currentItemCount = itemCount;
  }

  getSectionInnerHTML(html, selector) {
    if(!html) return ""
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }

  async updateDom() {
    const sections = await fetch(`${location.pathname}?sections=${this.getSectionsToRender().map(section => section.section)}`)
    const res = await sections.json()
    const parsedState_sections = res

    this.getSectionsToRender().forEach((section => {
      if(!section.id || !document.getElementById(section.id)) { return }
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

      elementToReplace.innerHTML =
        this.getSectionInnerHTML(parsedState_sections[section.section], section.selector);
    }));
  }
}


if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  });
};


export class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll('#cart-icon-bubble, #cart-icon-v5-menu-top, #cart-icon-v5-menu-main');
    if (cartLinks.length) {
      cartLinks.forEach((cartLink) => {
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        cartLink.setAttribute('aria-label', 'cart');

        cartLink.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(cartLink);
        });

        cartLink.addEventListener('keydown', (event) => {
          if (event.code.toUpperCase() === 'SPACE') {
            event.preventDefault();
            this.open(cartLink);
          }
        });
      });
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      let containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');

      // fix: product form addtocart first
      containerToTrapFocusOn = containerToTrapFocusOn ? containerToTrapFocusOn : document.getElementById('CartDrawer')
      containerToTrapFocusOn && trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    // 兼容 Shopify Upcart 插件
    const { upcartCartEnabled } = document.body.dataset
    if (upcartCartEnabled !== 'true') {
      // 设置 内容区域 宽度，防止 页面闪烁
      setContentWidth()
    }
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    // 恢复 内容区域 宽度
    resetContentWidth()
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  async renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    // fix no sections
    if (!parsedState?.items?.sections) {
      const sections = await fetch(`${location.pathname}?sections=${this.getSectionsToRender().map(section => section.id)}`)
      const res = await sections.json()
      parsedState.sections = res
    }

    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if(!sectionElement) return

      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);

      if(sectionElement.querySelector('cart-drawer-items') && !sectionElement.querySelector('cart-drawer-items').classList.contains('is-empty')) {
        sectionElement.parentElement.classList.remove('is-empty');
      }


      setTimeout(() => {
        try {
          const cart_item = $("#cart-icon-bubble .cart-count-bubble span").eq(0).text();
          cart_item && $(".m-header-icon .jackery-icon-gouwuche .cart-count-bubble").html(cart_item);
        } catch (error) {
          console.warn(error)
        }

        try {
          const cart_item = $("#cart-icon-v5-menu-top .cart-count-bubble span").eq(0).text();
          cart_item && $(".v5-header-announce .cart-count-bubble").html(cart_item);
        } catch (error) {
          console.warn(error)
        }
      }, 100)
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if(!html) return ''

    try {
      if(location.pathname.includes('/cart') && selector === "#main-cart-footer__js-contents") {
        document.querySelector(selector).querySelector(".totals__subtotal-value").textContent = new DOMParser().parseFromString(html, 'text/html').querySelector(".cart__footer .cart__blocks").getAttribute("data-totals__subtotal");
      }
    } catch (error) {
      console.warn("getSectionInnerHTML:", error)
    }


    return new DOMParser()
      ?.parseFromString(html, 'text/html')
      ?.querySelector(selector).innerHTML || '';
  }

  getSectionsToRender() { // 动态更新节点   FIX: SECTION RENDERING API最大sections参数数量为5
    if(document.querySelector("header-v5")) {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer'
        },
        {
          id: 'header-v5',
          section: 'header-v5',
          selector: '#cart-icon-v5-menu-top'
        },
        {
          id: 'header-v5-main',
          section: 'header-v5-main',
          selector: '.header-actions--cart'
        },
  
        // {
        //   id: 'main-cart-items',
        //   section: document.getElementById('main-cart-items')?.dataset?.id,
        //   selector: '.js-contents',
        // },
        // {
        //   id: 'main-cart-footer',
        //   section: document.getElementById('main-cart-footer')?.dataset?.id,
        //   selector: '#main-cart-footer__js-contents',
        // }
      ];
    } else {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer'
        },
        {
          id: 'cart-icon-bubble'
        },  
        // {
        //   id: 'main-cart-items',
        //   section: document.getElementById('main-cart-items')?.dataset?.id,
        //   selector: '.js-contents',
        // },
        // {
        //   id: 'main-cart-footer',
        //   section: document.getElementById('main-cart-footer')?.dataset?.id,
        //   selector: '.js-contents',
        // }
      ];
    }
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
export class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-v5-menu-top',
        section: 'header-v5',
        selector: '#cart-icon-v5-menu-top'
      },
      {
        id: 'cart-icon-v5-menu-main',
        section: 'header-v5-main',
        selector: '.header-actions--cart'
      }
    ];
  }
}
